import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { NotificationService } from '../../../notifications/notification.service';
import { CountryService } from '../country.service';
import {
    CountriesActionTypes, LoadCountries, LoadCountriesFail, LoadCountriesSuccess
} from './country.actions';

@Injectable()
export class CountriesEffects {


  constructor(
    private service: CountryService,
    private actions$: Actions,
    private notificationService: NotificationService,
    private translateService: TranslateService
  ) {
  }

  @Effect({ dispatch: false })
  genericFail$ = this.actions$.pipe(
    ofType<Action & { payload: string }>(
      CountriesActionTypes.LoadCountriesFail
    ),
    tap(action => this.notificationService.error(action.payload))
  );

  @Effect()
  searchCountries$ = this.actions$.pipe(
    ofType<LoadCountries>(CountriesActionTypes.LoadCountries),
    mergeMap((action) =>
      this.service.getAll().pipe(
        map(result => {
          result.forEach(country => country.name = this.translateService.instant(country.name));
          return new LoadCountriesSuccess(result);
        }),
        catchError(err => of(new LoadCountriesFail(err)))
      )
    )
  );

}
